import script from "./PinPhone.vue?vue&type=script&lang=ts&setup=true"
export * from "./PinPhone.vue?vue&type=script&lang=ts&setup=true"

import "./PinPhone.vue?vue&type=style&index=0&id=e8330286&lang=css"

const __exports__ = script;

export default __exports__